import styled from '@emotion/styled'

export const LineWrapper = styled.div`
  display: flex;
`
